var map = {
	"./button-text-block-quote-on.svg": 2256,
	"./button-text-block-quote.svg": 2257,
	"./button-text-bold-on.svg": 2258,
	"./button-text-bold.svg": 2259,
	"./button-text-bulleted-list-on.svg": 2260,
	"./button-text-bulleted-list.svg": 2261,
	"./button-text-deleted-on.svg": 2262,
	"./button-text-deleted.svg": 2263,
	"./button-text-formatting.svg": 1050,
	"./button-text-inline-code-on.svg": 2264,
	"./button-text-inline-code.svg": 2265,
	"./button-text-italic-on.svg": 2266,
	"./button-text-italic.svg": 2267,
	"./button-text-numbered-list-on.svg": 2268,
	"./button-text-numbered-list.svg": 2269,
	"./button-text-underlined-on.svg": 2270,
	"./button-text-underlined.svg": 2271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2255;